import { Box } from '@alf/uikit';
import GamesSectionHeader from '../../GamesSectionHeader';
import { RealTimeWinsItem } from './RealTimeWinsItem';
import { RealTimeWinsList } from './RealTimeWinsList';

import styles from './index.module.css';

export const RealTimeWins = ({ casinoType, delay }) => {
  return (
    <Box direction="column">
      <RealTimeWinsList
        casinoType={casinoType}
        delay={delay}
        headerComponent={GamesSectionHeader}
        itemComponent={RealTimeWinsItem}
        classNames={{
          realTimeWinsTitleWrapper: styles.realTimeWinsTitleWrapper
        }}
      />
    </Box>
  );
};
